import { useEffect } from 'react';
import { UseSetWidgetStatusProps, WidgetState } from './widget.types';

export const useSetWidgetQueryStatus = ({
  isFetching,
  isError,
  isSuccess,
  context
}: UseSetWidgetStatusProps) => {
  useEffect(() => {
    if (isFetching) {
      context?.setWidgetState(WidgetState.Loading);
      return;
    }
    if (isSuccess) {
      context?.setWidgetState(WidgetState.Success);
      return;
    }
    if (isError) {
      context?.setWidgetState(WidgetState.Error);
      return;
    }
  }, [isSuccess, isError, isFetching, context]);
};
